import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Palette, Users, Clock, Sparkles, FlameIcon, Scissors, Flower2, Gem, Printer, Cable } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { MiniFAQ } from '../components/MiniFAQ';
import { QuoteCard } from '../components/QuoteCard';
import { stories } from '../data/stories';
export function WorkshopsInfo() {
  return <div data-id="element-1500">
      {/* Hero section */}
      <section className="relative bg-gray-100 border-b border-gray-300" data-id="element-1501">
        <div className="relative h-[400px] md:h-[480px] overflow-hidden" data-id="element-1502">
          <div className="absolute inset-0 border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-100" data-id="element-1503">
            <span className="text-gray-400 text-lg" data-id="element-1504">Workshop sfeerbeeld</span>
          </div>
          <div className="absolute inset-0 flex flex-col items-center justify-center z-10 px-4 pointer-events-none" data-id="element-1505">
            <div className="bg-white/90 border border-gray-200 rounded-lg px-8 py-8 md:px-12 md:py-10 text-center pointer-events-auto" data-id="element-1506">
              <h1 className="text-4xl md:text-5xl font-bold" data-id="element-1507">Workshops</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4" data-id="element-1508">
        {/* Intro section */}
        <section className="py-16" data-id="element-1509">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center" data-id="element-1510">
            Leer iets nieuws, maak iets moois
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed text-center max-w-3xl mx-auto mb-10" data-id="element-1511">
            Bij De Maekerij organiseren we workshops rond de meest uiteenlopende
            creatieve thema's. Van keramiek tot fermenteren, van naaldvilten tot
            letterpress — er is voor iedereen iets bij. Onze workshops worden
            gegeven door ervaren lesgevers die hun passie graag met je delen.
          </p>

          {/* Intro with image */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto" data-id="element-1512">
            <div data-id="element-1513">
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1514">
                Of je nu een absolute beginner bent of al wat ervaring hebt,
                onze workshops zijn zo opgezet dat iedereen mee kan. Je krijgt
                alle materialen en begeleiding die je nodig hebt om met een mooi
                resultaat naar huis te gaan.
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-1515">
                We organiseren ook regelmatig ouder-kind workshops, zodat je
                samen met je kinderen creatief aan de slag kan. Kijk in onze
                kalender voor het volledige aanbod.
              </p>
            </div>
            <div className="border-2 border-dashed border-gray-300 h-64 flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-1516">
              <span className="text-gray-400" data-id="element-1517">Workshop sfeerbeeld</span>
            </div>
          </div>
        </section>

        {/* What to expect section */}
        <section className="pb-16" data-id="element-1518">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-1519">
            Wat kun je verwachten?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-1520">
            <Card variant="outlined" data-id="element-1521">
              <CardContent className="text-center" data-id="element-1522">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1523">
                  <Palette size={24} className="text-gray-400" data-id="element-1524" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1525">Alle materialen inbegrepen</h3>
                <p className="text-sm text-gray-600" data-id="element-1526">
                  Je hoeft niets mee te brengen. Alle materialen en gereedschap
                  zijn voorzien en inbegrepen in de prijs.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1527">
              <CardContent className="text-center" data-id="element-1528">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1529">
                  <Users size={24} className="text-gray-400" data-id="element-1530" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1531">Kleine groepen</h3>
                <p className="text-sm text-gray-600" data-id="element-1532">
                  We werken met kleine groepen zodat elke deelnemer voldoende
                  persoonlijke begeleiding krijgt van de lesgever.
                </p>
              </CardContent>
            </Card>

            <Card variant="outlined" data-id="element-1533">
              <CardContent className="text-center" data-id="element-1534">
                <div className="border border-dashed border-gray-300 w-16 h-16 rounded-full flex items-center justify-center bg-gray-100 mx-auto mb-4" data-id="element-1535">
                  <Clock size={24} className="text-gray-400" data-id="element-1536" />
                </div>
                <h3 className="font-bold mb-2" data-id="element-1537">Flexibele momenten</h3>
                <p className="text-sm text-gray-600" data-id="element-1538">
                  Workshops vinden plaats op verschillende dagen en tijdstippen:
                  overdag, 's avonds en in het weekend.
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* Workshop themes */}
        <section className="pb-16" data-id="element-1539">
          <div className="max-w-5xl mx-auto" data-id="element-1540">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-1541">
              Onze thema's
            </h2>
            <p className="text-gray-600 text-center max-w-2xl mx-auto mb-10" data-id="element-1542">
              Onze workshops zijn ingedeeld in verschillende thema's. Zo vind je
              snel iets dat bij jouw interesses past.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-1543">
              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1544">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1545">
                  <Sparkles size={24} data-id="element-1546" />
                </div>
                <span className="text-sm font-medium" data-id="element-1547">Keramiek</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1548">
                  Draaien, boetseren, glazuren
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1549">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1550">
                  <Cable size={24} data-id="element-1551" />
                </div>
                <span className="text-sm font-medium" data-id="element-1552">Draad</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1553">
                  Naaldvilten, macramé, weven
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1554">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1555">
                  <Printer size={24} data-id="element-1556" />
                </div>
                <span className="text-sm font-medium" data-id="element-1557">Druk</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1558">
                  Letterpress, linosnede, zeefdruk
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1559">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1560">
                  <FlameIcon size={24} data-id="element-1561" />
                </div>
                <span className="text-sm font-medium" data-id="element-1562">Koken</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1563">
                  Fermenteren, bakken, bewaren
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1564">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1565">
                  <Flower2 size={24} data-id="element-1566" />
                </div>
                <span className="text-sm font-medium" data-id="element-1567">Tuin</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1568">
                  Tuinontwerp, planten, bloemen
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1569">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1570">
                  <Gem size={24} data-id="element-1571" />
                </div>
                <span className="text-sm font-medium" data-id="element-1572">Juwelen</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1573">
                  Ringen, kettingen, armbanden
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1574">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1575">
                  <Scissors size={24} data-id="element-1576" />
                </div>
                <span className="text-sm font-medium" data-id="element-1577">Verzorging</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1578">
                  Parfum, zeep, cosmetica
                </span>
              </div>

              <div className="flex flex-col items-center text-center border border-gray-200 rounded-lg p-5 bg-white" data-id="element-1579">
                <div className="mb-3 p-3 bg-gray-100 rounded-full text-gray-600" data-id="element-1580">
                  <Palette size={24} data-id="element-1581" />
                </div>
                <span className="text-sm font-medium" data-id="element-1582">En meer...</span>
                <span className="text-xs text-gray-500 mt-1" data-id="element-1583">
                  Ons aanbod groeit steeds
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Ouder-kind workshops */}
        <section className="pb-16" data-id="element-1584">
          <div className="max-w-5xl mx-auto" data-id="element-1585">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1586">
              <div className="border-2 border-dashed border-gray-300 h-64 flex items-center justify-center bg-gray-100 rounded-lg" data-id="element-1587">
                <span className="text-gray-400" data-id="element-1588">
                  Ouder-kind workshop sfeerbeeld
                </span>
              </div>
              <div data-id="element-1589">
                <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1590">
                  Ouder-kind workshops
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-1591">
                  Speciaal voor gezinnen organiseren we regelmatig ouder-kind
                  workshops. Samen creatief bezig zijn is een geweldige manier
                  om quality time door te brengen. Van keramiek tot drukwerk —
                  er is altijd iets leuks te doen.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-1592">
                  Deze workshops zijn aangepast aan kinderen vanaf 6 jaar en
                  duren meestal 2 tot 3 uur. Alle materialen zijn inbegrepen.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA section */}
        <section className="mb-16" data-id="element-1593">
          <div className="max-w-3xl mx-auto text-center bg-gray-50 p-8 md:p-12 rounded-lg border border-gray-200" data-id="element-1594">
            <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1595">
              Bekijk de kalender
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1596">
              Ontdek alle komende workshops en schrijf je in. Plaatsen zijn
              beperkt, dus wacht niet te lang!
            </p>
            <Link to="/workshops?type=workshop" data-id="element-1597">
              <Button variant="primary" size="large" rightIcon={<ArrowRight size={18} data-id="element-1599" />} data-id="element-1598">
                Naar de kalender
              </Button>
            </Link>
          </div>
        </section>

        {/* Community stories */}
        <section className="mb-16" data-id="element-1600">
          <div className="max-w-3xl mx-auto" data-id="element-1601">
            <h2 className="text-xl font-bold mb-4" data-id="element-1602">Verhalen van deelnemers</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1603">
              {stories.filter(s => s.category === 'workshop').slice(0, 2).map((story, i) => <QuoteCard key={i} story={story} data-id="element-1604" />)}
            </div>
          </div>
        </section>

        {/* Practical info */}
        <section className="mb-8" data-id="element-1605">
          <div className="max-w-3xl mx-auto" data-id="element-1606">
            <Card variant="outlined" data-id="element-1607">
              <CardContent data-id="element-1608">
                <h3 className="font-bold mb-3" data-id="element-1609">Praktische informatie</h3>
                <div className="space-y-3 text-sm text-gray-600" data-id="element-1610">
                  <div data-id="element-1611">
                    <span className="font-medium text-gray-900" data-id="element-1612">Prijs:</span>{' '}
                    Varieert per workshop, meestal tussen €15 en €55. Alle
                    materialen zijn inbegrepen.
                  </div>
                  <div data-id="element-1613">
                    <span className="font-medium text-gray-900" data-id="element-1614">Duur:</span>{' '}
                    Meestal 2 tot 3 uur, afhankelijk van de workshop.
                  </div>
                  <div data-id="element-1615">
                    <span className="font-medium text-gray-900" data-id="element-1616">
                      Wat meenemen:
                    </span>{' '}
                    Niets! Alle materialen en gereedschap zijn voorzien. Draag
                    wel kleding die vuil mag worden.
                  </div>
                  <div data-id="element-1617">
                    <span className="font-medium text-gray-900" data-id="element-1618">
                      Inschrijven:
                    </span>{' '}
                    Verplicht, via de kalender. Plaatsen zijn beperkt.
                  </div>
                  <div data-id="element-1619">
                    <span className="font-medium text-gray-900" data-id="element-1620">
                      Annuleren:
                    </span>{' '}
                    Gratis annuleren tot 48 uur voor aanvang. Zie onze algemene
                    voorwaarden voor meer info.
                  </div>
                  <div data-id="element-1621">
                    <span className="font-medium text-gray-900" data-id="element-1622">
                      Cadeaubon:
                    </span>{' '}
                    Een workshop cadeau doen?{' '}
                    <Link to="/cadeaubonnen" className="underline hover:text-gray-900" data-id="element-1623">
                      Bestel een cadeaubon
                    </Link>
                    .
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* FAQ section */}
        <div className="max-w-3xl mx-auto mb-8" data-id="element-1624">
          <MiniFAQ category="Workshops" data-id="element-1625" />
        </div>
      </div>
    </div>;
}